import { __exports as TokenGeneratorMap } from './_virtual-TokenGeneratorMap.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireWeb_domCollections_iterator } from './node_modules-core-js-modules-web.dom-collections.iterator.js';
import { __require as requireDefineProperty } from './node_modules-@babel-runtime-helpers-defineProperty.js';
import { __require as requireQuantityPriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-QuantityPriceTokenGenerator.js';
import { __require as requirePriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-PriceTokenGenerator.js';
import { __require as requireRangePriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-RangePriceTokenGenerator.js';
import { __require as requireSavingsTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-SavingsTokenGenerator.js';
import { __require as requirePlusOrMinusTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-PlusOrMinusTokenGenerator.js';
import { __require as requirePercentageTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-PercentageTokenGenerator.js';
import { __require as requireUnitPriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-UnitPriceTokenGenerator.js';
import { __require as requireCouponCalloutTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-CouponCalloutTokenGenerator.js';
import { __require as requireVatTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-VatTokenGenerator.js';
import { __require as requireAsLowAsPricePerPiece } from './vp-js-token-engine-build-filters-asLowAsPricePerPiece.js';
import { __require as requireLabeledPrice } from './vp-js-token-engine-build-filters-labeledPrice.js';
import { __require as requirePricePerUnit } from './vp-js-token-engine-build-filters-pricePerUnit.js';
import { __require as requirePricePerPackage } from './vp-js-token-engine-build-filters-pricePerPackage.js';
import { __require as requirePricePerRecipient } from './vp-js-token-engine-build-filters-pricePerRecipient.js';
import { __require as requireQtyStartingAtPrice } from './vp-js-token-engine-build-filters-qtyStartingAtPrice.js';
import { __require as requireQtyForOnly } from './vp-js-token-engine-build-filters-qtyForOnly.js';
import { __require as requirePriceForQtyUnits } from './vp-js-token-engine-build-filters-priceForQtyUnits.js';
import { __require as requirePercentOff } from './vp-js-token-engine-build-filters-percentOff.js';
import { __require as requireYouSaved } from './vp-js-token-engine-build-filters-youSaved.js';
import { __require as requirePlusOrMinus } from './vp-js-token-engine-build-filters-plusOrMinus.js';
import { __require as requirePlusOrMinusPerUnit } from './vp-js-token-engine-build-filters-plusOrMinusPerUnit.js';
import { __require as requireRawPrice } from './vp-js-token-engine-build-filters-rawPrice.js';
import { __require as requireCouponCallout } from './vp-js-token-engine-build-filters-couponCallout.js';
import { __require as requireQtyForPrice } from './vp-js-token-engine-build-filters-qtyForPrice.js';
import { __require as requireQtyFromPrice } from './vp-js-token-engine-build-filters-qtyFromPrice.js';
import { __require as requireVatMessage } from './vp-js-token-engine-build-filters-vatMessage.js';
import { __require as requireRangePrice } from './vp-js-token-engine-build-filters-rangePrice.js';

var hasRequiredTokenGeneratorMap;

function requireTokenGeneratorMap () {
	if (hasRequiredTokenGeneratorMap) return TokenGeneratorMap;
	hasRequiredTokenGeneratorMap = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(TokenGeneratorMap, "__esModule", {
	  value: true
	});
	TokenGeneratorMap.default = void 0;
	requireWeb_domCollections_iterator();
	var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
	var _QuantityPriceTokenGenerator = _interopRequireDefault(requireQuantityPriceTokenGenerator());
	var _PriceTokenGenerator = _interopRequireDefault(requirePriceTokenGenerator());
	var _RangePriceTokenGenerator = _interopRequireDefault(requireRangePriceTokenGenerator());
	var _SavingsTokenGenerator = _interopRequireDefault(requireSavingsTokenGenerator());
	var _PlusOrMinusTokenGenerator = _interopRequireDefault(requirePlusOrMinusTokenGenerator());
	var _PercentageTokenGenerator = _interopRequireDefault(requirePercentageTokenGenerator());
	var _UnitPriceTokenGenerator = _interopRequireDefault(requireUnitPriceTokenGenerator());
	var _CouponCalloutTokenGenerator = _interopRequireDefault(requireCouponCalloutTokenGenerator());
	var _VatTokenGenerator = _interopRequireDefault(requireVatTokenGenerator());
	var asLowAsPricePerPiece = _interopRequireWildcard(requireAsLowAsPricePerPiece());
	var labeledPrice = _interopRequireWildcard(requireLabeledPrice());
	var pricePerUnit = _interopRequireWildcard(requirePricePerUnit());
	var pricePerPackage = _interopRequireWildcard(requirePricePerPackage());
	var pricePerRecipient = _interopRequireWildcard(requirePricePerRecipient());
	var qtyStartingAtPrice = _interopRequireWildcard(requireQtyStartingAtPrice());
	var qtyForOnly = _interopRequireWildcard(requireQtyForOnly());
	var priceForQtyUnits = _interopRequireWildcard(requirePriceForQtyUnits());
	var percentOff = _interopRequireWildcard(requirePercentOff());
	var youSaved = _interopRequireWildcard(requireYouSaved());
	var plusOrMinus = _interopRequireWildcard(requirePlusOrMinus());
	var plusOrMinusPerUnit = _interopRequireWildcard(requirePlusOrMinusPerUnit());
	var rawPrice = _interopRequireWildcard(requireRawPrice());
	var couponCallout = _interopRequireWildcard(requireCouponCallout());
	var qtyForPrice = _interopRequireWildcard(requireQtyForPrice());
	var qtyFromPrice = _interopRequireWildcard(requireQtyFromPrice());
	var vatMessage = _interopRequireWildcard(requireVatMessage());
	var rangePrice = _interopRequireWildcard(requireRangePrice());
	function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
	function _interopRequireWildcard(e, r) { if (e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
	let TokenGeneratorMap$1 = class TokenGeneratorMap {
	  constructor() {
	    (0, _defineProperty2.default)(this, "map", void 0);
	    (0, _defineProperty2.default)(this, "quantityPriceTokenGenerator", void 0);
	    (0, _defineProperty2.default)(this, "priceTokenGenerator", void 0);
	    (0, _defineProperty2.default)(this, "rangePriceTokenGenerator", void 0);
	    (0, _defineProperty2.default)(this, "unitPriceTokenGenerator", void 0);
	    (0, _defineProperty2.default)(this, "plusOrMinusTokenGenerator", void 0);
	    (0, _defineProperty2.default)(this, "savingsTokenGenerator", void 0);
	    (0, _defineProperty2.default)(this, "percentageTokenGenerator", void 0);
	    (0, _defineProperty2.default)(this, "couponCalloutGenerator", void 0);
	    (0, _defineProperty2.default)(this, "vatTokenGenerator", void 0);
	    this.quantityPriceTokenGenerator = new _QuantityPriceTokenGenerator.default();
	    this.priceTokenGenerator = new _PriceTokenGenerator.default();
	    this.rangePriceTokenGenerator = new _RangePriceTokenGenerator.default();
	    this.plusOrMinusTokenGenerator = new _PlusOrMinusTokenGenerator.default();
	    this.savingsTokenGenerator = new _SavingsTokenGenerator.default();
	    this.percentageTokenGenerator = new _PercentageTokenGenerator.default();
	    this.unitPriceTokenGenerator = new _UnitPriceTokenGenerator.default();
	    this.couponCalloutGenerator = new _CouponCalloutTokenGenerator.default();
	    this.vatTokenGenerator = new _VatTokenGenerator.default();
	    this.map = new Map();
	    this.map.set(qtyStartingAtPrice.name, this.quantityPriceTokenGenerator);
	    this.map.set(qtyFromPrice.name, this.quantityPriceTokenGenerator);
	    this.map.set(qtyForOnly.name, this.quantityPriceTokenGenerator);
	    this.map.set(priceForQtyUnits.name, this.quantityPriceTokenGenerator);
	    this.map.set(qtyForPrice.name, this.quantityPriceTokenGenerator);
	    this.map.set(asLowAsPricePerPiece.name, this.unitPriceTokenGenerator);
	    this.map.set(pricePerUnit.name, this.unitPriceTokenGenerator);
	    this.map.set(pricePerPackage.name, this.unitPriceTokenGenerator);
	    this.map.set(pricePerRecipient.name, this.unitPriceTokenGenerator);
	    this.map.set(labeledPrice.name, this.priceTokenGenerator);
	    this.map.set(plusOrMinus.name, this.plusOrMinusTokenGenerator);
	    this.map.set(plusOrMinusPerUnit.name, this.plusOrMinusTokenGenerator);
	    this.map.set(youSaved.name, this.savingsTokenGenerator);
	    this.map.set(percentOff.name, this.percentageTokenGenerator);
	    this.map.set(rawPrice.name, this.priceTokenGenerator);
	    this.map.set(couponCallout.name, this.couponCalloutGenerator);
	    this.map.set(vatMessage.name, this.vatTokenGenerator);
	    this.map.set(rangePrice.name, this.rangePriceTokenGenerator);
	  }
	  get(pricingType) {
	    return this.map.get(pricingType);
	  }
	};
	TokenGeneratorMap.default = TokenGeneratorMap$1;
	
	return TokenGeneratorMap;
}

export { requireTokenGeneratorMap as __require };
//# sourceMappingURL=vp-js-token-engine-build-tokenGenerators-TokenGeneratorMap.js.map
